/*
  Partspick — Quick model picker.

  Problem it fixes: the "Add to cart" buttons on collection grids, Best
  Sellers and New Arrivals either added the FIRST variant (e.g. iPhone 17
  Pro Max / Black while browsing iPhone 15 cases) or showed a dead-end
  "select model on the product page" message.

  Now: tapping "Add to cart" on any of those cards opens a small sheet where
  the shopper picks Model (+ Color), then the exact variant is added and the
  cart drawer opens. Single-variant products (accessories) are added
  straight away.
*/
(function () {
  if (window.__ppQuickPick) return;
  window.__ppQuickPick = true;

  var cache = {};
  var sheet = null;
  var state = null;

  var TRIGGERS = '.pp-collection-add, .pp-shelf-add, .fbt-add-btn';
  var FORM_TRIGGERS = 'form[data-pp-add-to-cart-form]';

  /* Cart drawer fix: when the cart was EMPTY at page load, <cart-drawer>
     keeps its "is-empty" class after an item is added through any custom
     button (quick-pick, bundle, New Arrivals...), which hides the whole
     item list — shoppers saw a blank cart. Every renderContents() call now
     clears that state first. */
  function patchCartDrawer() {
    var C = window.customElements && customElements.get('cart-drawer');
    if (!C || C.prototype.__ppEmptyFix) return;
    var original = C.prototype.renderContents;
    C.prototype.renderContents = function () {
      this.classList.remove('is-empty');
      var inner = this.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
      return original.apply(this, arguments);
    };
    C.prototype.__ppEmptyFix = true;
  }
  if (window.customElements) {
    patchCartDrawer();
    customElements.whenDefined('cart-drawer').then(patchCartDrawer);
  }

  function money(cents) {
    var n = (cents || 0) / 100;
    return 'Rs. ' + n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function norm(v) {
    return String(v || '').toLowerCase().replace(/\s+/g, '');
  }

  /* ---------- Remembered iPhone model (shared with the product page) ----------
     Stored in localStorage as "pp_model". Matching ignores spaces/case and
     understands combined values: "iPhone 13/14" matches "iPhone 14". */
  function modelKeys(v) {
    var k = norm(v);
    var out = [k];
    var m = k.match(/^([a-z]+)(.+)$/);
    if (m && m[2].indexOf('/') > -1) {
      m[2].split('/').forEach(function (part) { if (part) out.push(m[1] + part); });
    }
    return out;
  }
  function sameModel(a, b) {
    if (!a || !b) return false;
    var A = modelKeys(a), B = modelKeys(b);
    return A.some(function (x) { return B.indexOf(x) > -1; });
  }
  function savedModel() {
    try { return localStorage.getItem('pp_model') || ''; } catch (e) { return ''; }
  }
  function saveModel(v) {
    try { if (v) localStorage.setItem('pp_model', v); } catch (e) {}
  }
  window.ppModel = { get: savedModel, save: saveModel, same: sameModel };

  /* Resolve the product path for a trigger: from the card's product link,
     or (cart-drawer "Frequently bought together" buttons) from the variant id. */
  function resolvePath(el) {
    if (el.classList && el.classList.contains('fbt-add-btn')) {
      var id = el.getAttribute('data-variant-id');
      if (!id) return Promise.resolve(null);
      return fetch('/variants/' + id, { method: 'GET' }).then(function (r) {
        try {
          return new URL(r.url).pathname.replace(/\/$/, '');
        } catch (e) {
          return null;
        }
      });
    }
    return Promise.resolve(productUrlFrom(el));
  }

  /* iPhone models already in the cart — used to pre-select the model for
     accessories added from the cart drawer (e.g. lens protectors). */
  function cartModels() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var out = [];
        (c.items || []).forEach(function (it) {
          (it.options_with_values || []).forEach(function (o) {
            if (/iphone/i.test(o.value) && out.indexOf(o.value) === -1) out.push(o.value);
          });
        });
        return out;
      })
      .catch(function () { return []; });
  }

  function productUrlFrom(el) {
    var card = el.closest('li, .pp-shelf-item, [class*="__card"], .card-wrapper, .grid__item') || el.parentElement;
    var link = card && card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    try {
      var u = new URL(link.getAttribute('href'), window.location.origin);
      return u.pathname.replace(/\/$/, '');
    } catch (e) {
      return null;
    }
  }

  function fetchProduct(path) {
    if (cache[path]) return Promise.resolve(cache[path]);
    return fetch(path + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('product');
        return r.json();
      })
      .then(function (p) {
        cache[path] = p;
        return p;
      });
  }

  function cartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function addVariant(variantId, button) {
    var drawer = cartDrawer();
    var body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok || j.status) throw new Error(j.description || j.message || 'Could not add to cart');
          return j;
        });
      })
      .then(function (j) {
        if (drawer && typeof drawer.renderContents === 'function' && j.sections) {
          try {
            drawer.renderContents(j);
            return;
          } catch (e) {}
        }
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
      });
  }

  /* ---------------------------------------------------------------- UI */

  function injectStyles() {
    if (document.getElementById('pp-qp-styles')) return;
    var css =
      '.pp-qp-overlay{position:fixed;inset:0;background:rgba(10,10,12,.45);z-index:2147483000;opacity:0;transition:opacity .2s ease}' +
      '.pp-qp-overlay.is-open{opacity:1}' +
      '.pp-qp{position:fixed;left:0;right:0;bottom:0;z-index:2147483001;background:#fff;color:#14151A;border-radius:18px 18px 0 0;' +
      'max-height:86vh;display:flex;flex-direction:column;transform:translateY(100%);transition:transform .25s cubic-bezier(.2,.8,.2,1);' +
      'font-family:var(--font-body-family),-apple-system,BlinkMacSystemFont,"Helvetica Neue",Arial,sans-serif;box-shadow:0 -10px 40px rgba(0,0,0,.18)}' +
      '.pp-qp.is-open{transform:translateY(0)}' +
      '@media (min-width:750px){.pp-qp{left:50%;right:auto;bottom:auto;top:50%;width:460px;border-radius:18px;transform:translate(-50%,-46%);opacity:0;transition:transform .22s ease,opacity .22s ease}' +
      '.pp-qp.is-open{transform:translate(-50%,-50%);opacity:1}}' +
      '.pp-qp__head{display:flex;gap:12px;align-items:center;padding:18px 18px 12px;border-bottom:1px solid #eee}' +
      '.pp-qp__img{width:58px;height:58px;border-radius:10px;object-fit:cover;background:#f4f4f4;flex:0 0 58px}' +
      '.pp-qp__title{font-size:15px;font-weight:600;line-height:1.3;margin:0 0 4px}' +
      '.pp-qp__price{font-size:14px;font-weight:700;margin:0}' +
      '.pp-qp__price s{font-weight:400;color:#8a8d94;margin-left:6px;font-size:13px}' +
      '.pp-qp__close{margin-left:auto;align-self:flex-start;width:36px;height:36px;border:0;background:#f3f3f3;border-radius:50%;font-size:20px;line-height:1;cursor:pointer;color:#14151A}' +
      '.pp-qp__body{padding:6px 18px 8px;overflow:auto}' +
      '.pp-qp__label{font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;margin:14px 0 8px;display:flex;justify-content:space-between}' +
      '.pp-qp__label span{font-weight:500;text-transform:none;letter-spacing:0;color:#5c5e66}' +
      '.pp-qp__opts{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px}' +
      '.pp-qp__opt{min-height:42px;padding:8px 6px;border:1.5px solid #d9dbe0;border-radius:10px;background:#fff;color:#14151A;font-size:13px;font-weight:500;cursor:pointer;line-height:1.2}' +
      '.pp-qp__opt[aria-pressed="true"]{border-color:#14151A;background:#14151A;color:#fff}' +
      '.pp-qp__opt:disabled{opacity:.35;cursor:not-allowed;text-decoration:line-through}' +
      '.pp-qp__foot{padding:12px 18px calc(14px + env(safe-area-inset-bottom));border-top:1px solid #eee}' +
      '.pp-qp__add{width:100%;min-height:50px;border:0;border-radius:12px;background:#14151A;color:#fff;font-size:15px;font-weight:700;cursor:pointer}' +
      '.pp-qp__add:disabled{background:#c7c9ce;cursor:not-allowed}' +
      '.pp-qp__msg{font-size:12.5px;color:#c62828;margin:8px 0 0;min-height:1em;text-align:center}' +
      '.pp-qp__loading{padding:40px;text-align:center;font-size:14px;color:#5c5e66}';
    var style = document.createElement('style');
    style.id = 'pp-qp-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function closeSheet() {
    if (!sheet) return;
    sheet.panel.classList.remove('is-open');
    sheet.overlay.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    var s = sheet;
    sheet = null;
    setTimeout(function () {
      s.panel.remove();
      s.overlay.remove();
    }, 250);
    document.body.style.overflow = '';
    if (state && state.returnFocus) {
      try { state.returnFocus.focus(); } catch (e) {}
    }
    state = null;
  }

  function onKey(e) {
    if (e.key === 'Escape') closeSheet();
  }

  function openShell(returnFocus) {
    injectStyles();
    if (sheet) closeSheet();
    var overlay = el('div', 'pp-qp-overlay');
    var panel = el('div', 'pp-qp');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Choose your model');
    panel.appendChild(el('div', 'pp-qp__loading', 'Loading options…'));
    overlay.addEventListener('click', closeSheet);
    document.body.appendChild(overlay);
    document.body.appendChild(panel);
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      panel.classList.add('is-open');
    });
    document.addEventListener('keydown', onKey);
    sheet = { overlay: overlay, panel: panel };
    state = { returnFocus: returnFocus };
  }

  function matching(product, selected, uptoIndex) {
    return product.variants.filter(function (v) {
      for (var i = 0; i < uptoIndex; i++) {
        if (selected[i] != null && v.options[i] !== selected[i]) return false;
      }
      return true;
    });
  }

  function findVariant(product, selected) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var ok = true;
      for (var j = 0; j < product.options.length; j++) {
        if (v.options[j] !== selected[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function render(product) {
    if (!sheet) return;
    var panel = sheet.panel;
    panel.innerHTML = '';
    var selected = state.selected;

    var head = el('div', 'pp-qp__head');
    var imgSrc = product.featured_image;
    var variant = findVariant(product, selected);
    if (variant && variant.featured_image) imgSrc = variant.featured_image.src;
    if (imgSrc) {
      var img = el('img', 'pp-qp__img');
      img.src = imgSrc + (imgSrc.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      img.alt = '';
      head.appendChild(img);
    }
    var info = el('div');
    info.appendChild(el('p', 'pp-qp__title', product.title));
    var price = el('p', 'pp-qp__price');
    var shown = variant || product.variants[0];
    price.textContent = money(shown.price);
    if (shown.compare_at_price && shown.compare_at_price > shown.price) {
      var s = el('s', null, money(shown.compare_at_price));
      price.appendChild(s);
    }
    info.appendChild(price);
    head.appendChild(info);
    var close = el('button', 'pp-qp__close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    close.addEventListener('click', closeSheet);
    head.appendChild(close);
    panel.appendChild(head);

    var body = el('div', 'pp-qp__body');
    product.options.forEach(function (opt, idx) {
      var name = typeof opt === 'string' ? opt : opt.name;
      var values = typeof opt === 'string' ? [] : opt.values;
      if (!values.length) {
        product.variants.forEach(function (v) {
          if (values.indexOf(v.options[idx]) === -1) values.push(v.options[idx]);
        });
      }
      var label = el('p', 'pp-qp__label', name);
      label.appendChild(el('span', null, selected[idx] || 'Select'));
      body.appendChild(label);
      var grid = el('div', 'pp-qp__opts');
      var pool = matching(product, selected, idx);
      values.forEach(function (val) {
        var b = el('button', 'pp-qp__opt', val);
        b.type = 'button';
        b.setAttribute('aria-pressed', selected[idx] === val ? 'true' : 'false');
        var possible = pool.some(function (v) { return v.options[idx] === val && v.available; });
        if (!possible) b.disabled = true;
        b.addEventListener('click', function () {
          selected[idx] = val;
          for (var k = idx + 1; k < product.options.length; k++) {
            var still = matching(product, selected, k).some(function (v) {
              return v.options[k] === selected[k] && v.available;
            });
            if (!still) selected[k] = null;
          }
          render(product);
        });
        grid.appendChild(b);
      });
      body.appendChild(grid);
    });
    panel.appendChild(body);

    var foot = el('div', 'pp-qp__foot');
    var add = el('button', 'pp-qp__add');
    add.type = 'button';
    var msg = el('p', 'pp-qp__msg');
    if (variant && variant.available) {
      add.textContent = 'Add to cart — ' + money(variant.price);
    } else if (variant) {
      add.textContent = 'Sold out';
      add.disabled = true;
    } else {
      add.textContent = 'Select ' + product.options.map(function (o) { return typeof o === 'string' ? o : o.name; }).join(' & ');
      add.disabled = true;
    }
    add.addEventListener('click', function () {
      if (!variant) return;
      add.disabled = true;
      add.textContent = 'Adding…';
      addVariant(variant.id)
        .then(function () {
          closeSheet();
        })
        .catch(function (err) {
          add.disabled = false;
          add.textContent = 'Add to cart — ' + money(variant.price);
          msg.textContent = err && err.message ? err.message : 'Could not add to cart. Please try again.';
        });
    });
    foot.appendChild(add);
    foot.appendChild(msg);
    panel.appendChild(foot);

    var first = panel.querySelector('.pp-qp__opt:not(:disabled)');
    if (first && !state.focused) {
      state.focused = true;
      try { first.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function handle(trigger, event) {
    var isFbt = trigger.classList && trigger.classList.contains('fbt-add-btn');
    if (!isFbt && !productUrlFrom(trigger)) return; // let the section's own handler run
    event.preventDefault();
    event.stopImmediatePropagation();

    var button = trigger.tagName === 'FORM' ? trigger.querySelector('button[type="submit"]') : trigger;
    if (button && button.disabled) return;

    var pathPromise = resolvePath(trigger);
    /* Model is never pre-selected: the shopper must pick it every time. */
    var modelsPromise = Promise.resolve([]);

    Promise.all([pathPromise, modelsPromise])
      .then(function (res) {
        var path = res[0];
        var models = res[1];
        if (!path) throw new Error('no product');
        return fetchProduct(path).then(function (product) {
          var available = product.variants.filter(function (v) { return v.available; });
          if (!available.length) return;
          if (product.variants.length === 1 || product.has_only_default_variant) {
            var label = button ? button.textContent : '';
            if (button) { button.disabled = true; button.textContent = 'Adding…'; }
            return addVariant(product.variants[0].id).then(function () {
              if (button) { button.textContent = 'Added'; }
              setTimeout(function () {
                if (button) { button.disabled = false; button.textContent = label; }
              }, 1400);
            }, function () {
              if (button) { button.disabled = false; button.textContent = label; }
            });
          }
          openShell(button);
          state.selected = product.options.map(function () { return null; });
          /* pre-select the iPhone model already in the cart, if offered */
          if (models.length) {
            for (var m = 0; m < models.length; m++) {
              var target = models[m];
              var hit = null;
              product.variants.some(function (v) {
                for (var i = 0; i < v.options.length; i++) {
                  if (sameModel(v.options[i], target) && v.available) { hit = { idx: i, val: v.options[i] }; return true; }
                }
                return false;
              });
              if (hit) { state.selected[hit.idx] = hit.val; break; }
            }
          }
          render(product);
        });
      })
      .catch(function () {
        var p = productUrlFrom(trigger);
        if (p) window.location.href = p;
      });
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target.closest && e.target.closest(TRIGGERS);
      if (t) handle(t, e);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var f = e.target;
      if (f && f.matches && f.matches(FORM_TRIGGERS)) handle(f, e);
    },
    true
  );
})();

/*
  Partspick — conversion helpers (site-wide).
  1. (removed) Model and colour are never pre-selected.
  2. Product page: delivery estimate (2-5 business days) + COD line.
  3. Cart drawer: "Buy 2 / Buy 3" offer progress bar using the site's own
     advertised codes (PREPAID350 / PREPAID475).
  4. Videos: autoplay reels only while on screen (saves data + CPU).
*/
(function () {
  if (window.__ppCro) return;
  window.__ppCro = true;

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------- 2. Delivery estimate ---------- */
  function addBusinessDays(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) {
      r.setDate(r.getDate() + 1);
      if (r.getDay() !== 0) n--; /* skip Sundays */
    }
    return r;
  }
  function fmt(d) {
    try {
      return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    } catch (e) {
      return d.toDateString();
    }
  }
  function deliveryEstimate() {
    var info = document.querySelector('.product__info-container');
    if (!info || info.querySelector('.pp-eta')) return;
    var submit = info.querySelector('.product-form__submit');
    if (!submit) return;
    var anchor = info.querySelector('.product-form__inline-row') || submit.closest('product-form');
    if (!anchor) return;
    var now = new Date();
    var box = document.createElement('div');
    box.className = 'pp-eta';
    box.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3v4h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>' +
      '<div><strong></strong><span>Cash on Delivery available &middot; Replacement if it arrives wrong or damaged</span></div>';
    box.querySelector('strong').textContent =
      'Order now, get it by ' + fmt(addBusinessDays(now, 2)) + ' – ' + fmt(addBusinessDays(now, 5));
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
  }

  /* ---------- 3. Cart drawer offer progress ---------- */
  var nudgeTimer = null;
  function renderNudge() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cases = 0;
        (cart.items || []).forEach(function (it) {
          if (/case/i.test(it.product_title || it.title || '')) cases += it.quantity;
        });
        var old = drawer.querySelector('.pp-nudge');
        if (old) old.remove();
        if (!cases) return;
        var html;
        var pct;
        if (cases === 1) {
          html = 'Add <b>1 more case</b> &amp; get <b>flat ₹350 OFF</b> with code <b>PREPAID350</b> (prepaid).';
          pct = 50;
        } else if (cases === 2) {
          html = '<b>₹350 OFF unlocked</b> (PREPAID350). Add <b>1 more case</b> for <b>₹475 OFF</b> with <b>PREPAID475</b>.';
          pct = 75;
        } else {
          html = '<b>₹475 OFF unlocked!</b> Use code <b>PREPAID475</b> when you pay online.';
          pct = 100;
        }
        var box = document.createElement('div');
        box.className = 'pp-nudge';
        box.innerHTML = html + '<div class="pp-nudge__bar"><i style="width:' + pct + '%"></i></div>';
        var host = drawer.querySelector('cart-drawer-items') || drawer.querySelector('.drawer__contents') || drawer.querySelector('.drawer__inner');
        if (host) host.insertBefore(box, host.firstChild);
      })
      .catch(function () {});
  }
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    renderNudge();
    new MutationObserver(function (list) {
      var own = list.every(function (m) {
        return Array.prototype.every.call(m.addedNodes, function (n) { return n.classList && n.classList.contains('pp-nudge'); }) &&
          Array.prototype.every.call(m.removedNodes, function (n) { return n.classList && n.classList.contains('pp-nudge'); });
      });
      if (own) return;
      clearTimeout(nudgeTimer);
      nudgeTimer = setTimeout(renderNudge, 250);
    }).observe(drawer, { childList: true, subtree: true });
  }

  /* ---------- 4. Play reels only while visible ---------- */
  function lazyVideos() {
    if (!('IntersectionObserver' in window)) return;
    var vids = document.querySelectorAll('video.pp-reel-video-el, .shopify-section video[autoplay]');
    if (!vids.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.preload === 'none') v.preload = 'auto';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0.1 });
    Array.prototype.forEach.call(vids, function (v) {
      var r = v.getBoundingClientRect();
      var near = r.top < window.innerHeight + 200 && r.bottom > -200;
      if (!near) {
        v.removeAttribute('autoplay');
        v.pause();
        if (v.readyState < 3) {
          v.preload = 'none';
          try { v.load(); } catch (e) {}
        }
      }
      io.observe(v);
    });
  }

  onReady(function () {
    lazyVideos();
    deliveryEstimate();
    watchDrawer();
  });
})();

/*
  Partspick — more conversion helpers.
  5. Back-in-stock: "Notify me" form when the chosen model/colour is sold out
     (sent to the store inbox through Shopify's own contact form).
  6. Sticky Add to cart bar: model dropdown, so shoppers can pick a model
     without scrolling back up.
  7. Search: typing an iPhone model shows a "Shop all iPhone 15 cases" link
     to that model's collection (also on the search results page).
  8. Cart drawer: trust line next to the checkout button.
*/
(function () {
  if (window.__ppCro2) return;
  window.__ppCro2 = true;

  var CSS =
    '.pp-notify{margin:14px 0 4px;padding:14px;border:1px solid #fecaca;border-radius:10px;background:#fff7f7;color:#14151a;font-size:13px;line-height:1.4}' +
    '.pp-notify p{margin:0 0 10px}.pp-notify b{font-weight:700}' +
    '.pp-notify__row{display:flex;gap:8px;flex-wrap:wrap}' +
    '.pp-notify input{flex:1 1 180px;min-width:0;height:44px;padding:0 12px;border:1px solid #d4d4d8;border-radius:8px;font:inherit;font-size:14px;background:#fff}' +
    '.pp-notify button{flex:0 0 auto;height:44px;padding:0 18px;border:0;border-radius:8px;background:#14151a;color:#fff;font:inherit;font-size:14px;font-weight:700;cursor:pointer}' +
    '.pp-notify button:disabled{opacity:.6;cursor:default}' +
    '.pp-notify__msg{margin:8px 0 0!important;font-size:12.5px}.pp-notify__msg.is-ok{color:#15803d}.pp-notify__msg.is-err{color:#c62828}' +
    '.pp-sticky-model{flex:1 1 auto;min-width:0;max-width:220px;height:40px;padding:0 28px 0 10px;border:1.3px solid #d4d4d8;border-radius:8px;background:#fff;color:#14151a;font:inherit;font-size:13px;font-weight:600;appearance:none;-webkit-appearance:none;' +
    'background-image:linear-gradient(45deg,transparent 50%,#55555c 50%),linear-gradient(135deg,#55555c 50%,transparent 50%);background-position:calc(100% - 15px) 17px,calc(100% - 10px) 17px;background-size:5px 5px,5px 5px;background-repeat:no-repeat}' +
    '.pp-sticky-model.is-missing{border-color:#d92d20;box-shadow:0 0 0 3px rgba(217,45,32,.1)}' +
    '@media (max-width:749px){.pp-sticky.pp-has-model .pp-sticky-title{display:none}.pp-sticky.pp-has-model .pp-sticky-img{display:none}.pp-sticky.pp-has-model .pp-sticky-inner{gap:8px}.pp-sticky.pp-has-model .pp-sticky-info{flex:0 0 auto}}' +
    '.pp-model-hit{display:flex;align-items:center;justify-content:space-between;gap:10px;margin:8px 0;padding:11px 14px;border-radius:10px;background:#14151a;color:#fff!important;text-decoration:none!important;font-size:14px;font-weight:600}' +
    '.pp-model-hit span:last-child{font-size:18px;line-height:1}' +
    '.pp-cart-trust{display:flex;justify-content:center;flex-wrap:wrap;gap:4px 12px;margin:10px 0 0;font-size:12px;color:#5c5e66;text-align:center}' +
    '.pp-cart-trust span{white-space:nowrap}.pp-cart-trust span::before{content:"\\2713";color:#15803d;font-weight:700;margin-right:4px}';

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function injectCss() {
    if (document.getElementById('pp-cro2-css')) return;
    var st = document.createElement('style');
    st.id = 'pp-cro2-css';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  /* ---------- 5. Back-in-stock ---------- */
  function variantLabel() {
    var parts = [];
    document.querySelectorAll('.pp-custom-dropdown .pp-dropdown-option[data-selected="true"]').forEach(function (o) {
      parts.push(o.getAttribute('data-value'));
    });
    return parts.join(' / ');
  }
  function currentVariantId() {
    var f = document.querySelector('.product__info-container form[data-type="add-to-cart-form"] input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return f ? f.value : '';
  }
  function isSoldOut(btn) {
    return !!btn && btn.disabled && (btn.getAttribute('data-pp-sold-out') === 'true' || /sold\s*out/i.test(btn.textContent));
  }
  function backInStock() {
    var info = document.querySelector('.product__info-container');
    var btn = info && info.querySelector('.product-form__submit');
    if (!btn) return;
    var titleEl = info.querySelector('.product__title h1, .product__title h2');
    var box = null;

    function build() {
      box = document.createElement('div');
      box.className = 'pp-notify';
      box.innerHTML =
        '<p><b>This one is sold out.</b> Leave your email and we’ll tell you as soon as it’s back.</p>' +
        '<form class="pp-notify__row" novalidate>' +
        '<input type="email" name="email" placeholder="Your email" autocomplete="email" required aria-label="Email">' +
        '<input type="tel" name="phone" placeholder="WhatsApp number (optional)" autocomplete="tel" aria-label="WhatsApp number">' +
        '<button type="submit">Notify me</button></form>' +
        '<p class="pp-notify__msg" role="status"></p>';
      var form = box.querySelector('form');
      var msg = box.querySelector('.pp-notify__msg');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = form.email.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          msg.className = 'pp-notify__msg is-err';
          msg.textContent = 'Please enter a valid email.';
          return;
        }
        var b = form.querySelector('button');
        b.disabled = true;
        b.textContent = 'Sending…';
        var fd = new FormData();
        fd.append('form_type', 'contact');
        fd.append('utf8', '✓');
        fd.append('contact[name]', 'Back in stock request');
        fd.append('contact[email]', email);
        if (form.phone.value.trim()) fd.append('contact[phone]', form.phone.value.trim());
        fd.append('contact[body]',
          'BACK IN STOCK REQUEST\nProduct: ' + (titleEl ? titleEl.textContent.trim() : document.title) +
          '\nOption: ' + (variantLabel() || '-') +
          '\nVariant ID: ' + currentVariantId() +
          '\nPage: ' + window.location.origin + window.location.pathname);
        fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
          .then(function (r) {
            if (/\/challenge/.test(r.url)) throw new Error('challenge');
            if (!r.ok) throw new Error('fail');
            msg.className = 'pp-notify__msg is-ok';
            msg.textContent = 'Done! We’ll let you know when it’s back in stock.';
            form.style.display = 'none';
          })
          .catch(function () {
            b.disabled = false;
            b.textContent = 'Notify me';
            msg.className = 'pp-notify__msg is-err';
            msg.textContent = 'Could not send right now. Please try again.';
          });
      });
    }
    function sync() {
      var sold = isSoldOut(btn);
      var eta = info.querySelector('.pp-eta');
      if (sold) {
        if (!box) build();
        if (!box.isConnected) {
          var anchor = eta || info.querySelector('.product-form__inline-row') || btn.closest('product-form');
          if (anchor) anchor.parentNode.insertBefore(box, anchor.nextSibling);
        }
        if (eta) eta.style.display = 'none';
      } else {
        if (box && box.isConnected) box.remove();
        if (eta) eta.style.display = '';
      }
    }
    new MutationObserver(sync).observe(btn, { attributes: true, childList: true, subtree: true, characterData: true });
    setTimeout(sync, 300);
  }

  /* ---------- 6. Model dropdown in the sticky bar ---------- */
  function stickyModel() {
    var bar = document.querySelector('.pp-sticky');
    var dd = document.querySelector('.pp-custom-dropdown[data-dropdown="device"]');
    if (!bar || !dd || bar.querySelector('.pp-sticky-model')) return;
    var opts = Array.prototype.slice.call(dd.querySelectorAll('.pp-dropdown-option'));
    if (opts.length < 2) return;
    var sel = document.createElement('select');
    sel.className = 'pp-sticky-model';
    sel.setAttribute('aria-label', 'Select your model');
    var first = document.createElement('option');
    first.value = '';
    first.textContent = 'Select model';
    sel.appendChild(first);
    opts.forEach(function (o) {
      var op = document.createElement('option');
      op.value = o.getAttribute('data-value');
      op.textContent = o.getAttribute('data-value');
      sel.appendChild(op);
    });
    var btn = bar.querySelector('[data-sticky-add]');
    btn.parentNode.insertBefore(sel, btn);
    bar.classList.add('pp-has-model');

    sel.addEventListener('change', function () {
      var hit = opts.filter(function (o) { return o.getAttribute('data-value') === sel.value; })[0];
      if (!hit) return;
      hit.click();
      sel.classList.remove('is-missing');
    });
    function reflect() {
      var on = dd.querySelector('.pp-dropdown-option[data-selected="true"]');
      var v = on ? on.getAttribute('data-value') : '';
      if (sel.value !== v) sel.value = v;
      if (v) sel.classList.remove('is-missing');
    }
    new MutationObserver(reflect).observe(dd, { attributes: true, attributeFilter: ['data-selected'], subtree: true });
    reflect();

    /* sticky Add to cart without a model: highlight the dropdown right here
       instead of jumping the page up */
    btn.addEventListener('click', function (e) {
      if (sel.value) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      sel.classList.add('is-missing');
      try { sel.focus(); } catch (err) {}
      if (typeof sel.showPicker === 'function') { try { sel.showPicker(); } catch (err) {} }
    }, true);
  }

  /* ---------- 7. Model shortcut in search ---------- */
  var MODEL_HANDLES = ['iphone-11', 'iphone-11-pro', 'iphone-11-pro-max-1', 'iphone-12', 'iphone-12-mini', 'iphone-12-pro', 'iphone-12-pro-max',
    'iphone-13', 'iphone-13-mini', 'iphone-13-pro', 'iphone-13-pro-max', 'iphone-14', 'iphone-14-plus', 'iphone-14-pro', 'iphone-14-pro-max',
    'iphone-15', 'iphone-15-plus', 'iphone-15-pro', 'iphone-15-pro-max', 'iphone-16', 'iphone-16-plus', 'iphone-16-pro', 'iphone-16-pro-max',
    'iphone-17', 'iphone-17-air', 'iphone-17-pro', 'iphone-17-pro-max'];
  function modelFromQuery(q) {
    var m = String(q || '').toLowerCase().match(/(?:iphone|i\s*phone|ip)\s*(1[1-7])\s*(pro\s*max|promax|pro|plus|mini|air)?/);
    if (!m) return null;
    var variant = (m[2] || '').replace(/\s+/g, '');
    if (variant === 'promax') variant = 'pro-max';
    var handle = 'iphone-' + m[1] + (variant ? '-' + variant : '');
    if (MODEL_HANDLES.indexOf(handle) === -1) {
      if (MODEL_HANDLES.indexOf(handle + '-1') > -1) handle = handle + '-1';
      else return null;
    }
    var label = 'iPhone ' + m[1] + (variant ? ' ' + variant.replace('-', ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }) : '');
    return { handle: handle, label: label };
  }
  function modelLink(model) {
    var a = document.createElement('a');
    a.className = 'pp-model-hit';
    a.href = '/collections/' + model.handle;
    a.innerHTML = '<span></span><span aria-hidden="true">→</span>';
    a.firstChild.textContent = 'Shop all ' + model.label + ' cases';
    return a;
  }
  function searchShortcut() {
    document.addEventListener('input', function (e) {
      var input = e.target;
      if (!input || input.name !== 'q' || !input.closest) return;
      var form = input.closest('form');
      if (!form) return;
      var holder = form.parentNode;
      var old = holder.querySelector(':scope > .pp-model-hit');
      var model = modelFromQuery(input.value);
      if (!model) { if (old) old.remove(); return; }
      if (old && old.getAttribute('href') === '/collections/' + model.handle) return;
      if (old) old.remove();
      holder.insertBefore(modelLink(model), form.nextSibling);
    });
    /* search results page */
    if (/^\/search/.test(window.location.pathname)) {
      var q = new URLSearchParams(window.location.search).get('q');
      var model = modelFromQuery(q);
      var anchor = document.querySelector('.template-search__header, .template-search .search, main h1');
      if (model && anchor) anchor.parentNode.insertBefore(modelLink(model), anchor.nextSibling);
    }
  }

  /* ---------- 8. Cart drawer trust line ---------- */
  function cartTrust() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    function put() {
      var ctas = drawer.querySelector('.cart__ctas');
      if (!ctas || ctas.querySelector('.pp-cart-trust')) return;
      var line = document.createElement('div');
      line.className = 'pp-cart-trust';
      line.innerHTML = '<span>COD available</span><span>Secure checkout</span><span>Easy replacement</span>';
      ctas.appendChild(line);
    }
    put();
    new MutationObserver(function () { put(); }).observe(drawer, { childList: true, subtree: true });
  }

  onReady(function () {
    injectCss();
    backInStock();
    stickyModel();
    searchShortcut();
    cartTrust();
  });
})();